export default __webpack_public_path__ + "static/media/169.a2790840.jpg";